import React from 'react';
import { Alert } from './Alert';

function cleanErrorMessage(message = '') {
	return message
		.replace('GraphQL error: ', '')
		.replace(/^SafeError\s*/, '');
}

export function interpretGraphqlError(error, knownErrorCodes = {}) {
	if (error.paymentStripe) return error.message;

	console.error('GraphQLError', error); // eslint-disable-line no-console

	// Normal GraphQL errors arrive on `graphQLErrors`, but Apollo wraps any
	// non-2xx HTTP response (e.g. the API's 422 validation errors) as a
	// `networkError`/`ServerError` with an empty `graphQLErrors` array. In that
	// case the real messages live on `networkError.result.errors`.
	const graphQLErrors =
		(error.graphQLErrors && error.graphQLErrors.length && error.graphQLErrors) ||
		(error.networkError && error.networkError.result && error.networkError.result.errors) ||
		[];

	if (graphQLErrors.length) {
		const messages = graphQLErrors.reduce((acc, e) => {
			const code = e.code || (e.extensions && e.extensions.code);
			if (code && knownErrorCodes[code]) {
				acc.push(knownErrorCodes[code]);
			}
			return acc;
		}, []);

		if (messages.length > 0) {
			return messages.join(' ');
		}

		return cleanErrorMessage(graphQLErrors[0].message || error.message || '');
	}

	if (error.networkError) {
		return 'There was a problem contacting the server. Please try again later.';
	}

	if (error.message) {
		return cleanErrorMessage(error.message);
	}

	return 'There was an error processing your request. Please try again later.';
}

export function GraphqlErrorMessage({ error, knownErrorCodes, ...props }) {
	return <Alert flavour="danger" {...props}>
		{interpretGraphqlError(error, knownErrorCodes)}
	</Alert>
}

export function ValidationErrorMessage({ error, ...props }) {
	return <Alert flavour="danger" {...props}>
		<strong>Validation error</strong>
		<br />
		{error ? (error.message || error) : 'Please check the highlighted fields.'}
	</Alert>
}
